export function submitEditCustomCsvCustomer()
{
    return({
        type:"EDIT_CUSTOM_CSV_CUSTOMER"
    })
}